module.exports = __webpack_public_path__ + "3d600437bc4b82cc118d841844d815f5.svg";


//////////////////
// WEBPACK FOOTER
// ./~/flag-icon-css/flags/1x1/vg.svg
// module id = ./node_modules/flag-icon-css/flags/1x1/vg.svg
// module chunks = 0